<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" :loading="loadingServerSide">
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.payer_name }}</td>
          <td>{{ formatMoney(item.amount_paid) }}</td>
          <td>{{ dateFormat(item.date_transaction) }}</td>
          <td>
            <v-tooltip bottom v-if="authPermissions.has('consumer_loans:edit')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on" color="yellow"
                  @click="editTransaction(item)">
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template v-slot:[`body.append`]>
        <tr>
          <th class="primary--text">Total Amount</th>
          <td>{{ formatMoney(totalAmountPaid) }}</td>
          <td colspan="2"></td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
import { moneyMixin, dateFormatMixin } from '@/views/dashboard/mixins/helper.mixins'
import { errorHandler } from '@/extra-functions/store.extra'
import { mapState } from 'vuex'
export default {
  name: 'index-consumer-loan-transaction',
  props: {
    propConsumerId: String,
    propConsumerLoanId: String,
  },
  mounted() {
    this.getTransactions()
  },
  data() {
    return {
      headers: [
        { text: 'Name', sortable: false },
        { text: 'Amount Paid', sortable: false },
        { text: 'Date', sortable: false },
        { text: 'Config', sortable: false },
      ],
      items: [],
      errors: [],
      loadingServerSide: false,
    }
  },
  computed: {
    ...mapState({
      storeId: state => state.settings.storeId,
      transactionUpdated: state => state.consumerLoanTransaction.channelUpdate,
      authPermissions: state => state.auth.userPermissions,
    }),
    totalAmountPaid() {
      return this.items.reduce((t, c) => {
        return t + c.amount_paid
      }, 0)
    },
  },
  watch: {
    transactionUpdated() {
      this.getTransactions()
    },
  },
  methods: {
    async getTransactions() {
      if (!this.loadingServerSide) {
        this.loadingServerSide = true
        this.errors = []
        const queryString = {
          consumer: this.propConsumerId,
          consumerLoan: this.propConsumerLoanId,
        }
        CLTRepository.index(queryString)
          .then(({ data }) => { this.items = data })
          .catch(e => { this.errors = errorHandler(e) })
          .then(() => { this.loadingServerSide = false })
      }
    },
    editTransaction(item) {
      this.$emit('edit', item)
    },
  },
  mixins: [
    moneyMixin,
    dateFormatMixin,
  ],
}
</script>
